<template>
  <div class="scrollbar-hidden flex h-8 justify-end overflow-x-scroll text-xs">
    <div class="h-8 grow border-t border-gray-300/75 py-2"></div>
    <ParagraphHistoryLink
      v-for="ancestor in paragraph.ancestors"
      :key="ancestor.id"
      class="rounded-b-md border p-2"
      :class="
        active === ancestor.id ? 'border-t-transparent' : 'border-t-gray-300/75'
      "
      :active="active === ancestor.id"
      :paragraph="ancestor"
    />
    <LocaleLink class="link border-t border-t-gray-300/75 p-2" :href="href">
      {{ $t("legal_text.middleColumn.navigation.current_version") }}
    </LocaleLink>
  </div>
</template>

<script lang="ts" setup>
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

type Props = {
  active: number | undefined;
  paragraph: ILegalTextParagraph;
};

const props = defineProps<Props>();

const { href } = useParagraphLink({
  legalTextSlug: props.paragraph.legal_text!.slug,
  paragraphSlug: props.paragraph.slug,
});
</script>
